import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import getters from './getters';
import print from './modules/print';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    print,
  },
  getters,
});
